/**
 * Detecção de "app instalado" (PWA) — usada para bloquear o acesso pelo app e
 * empurrar o usuário pro navegador.
 *
 * O CreditOS deixou de ser usado como app instalado (PWA desativado): tirar o
 * manifest impede NOVAS instalações, mas quem já instalou continua com o ícone.
 * Para esses, mostramos uma tela de bloqueio quando o app é aberto em modo
 * "instalado".
 *
 * Conservador DE PROPÓSITO: só casa com os modos que o app instalado de fato usa
 * (`display-mode: standalone`, que era o do nosso manifest) + o caso do iOS
 * (`navigator.standalone`). NÃO usa `minimal-ui`/`fullscreen` justamente para
 * NÃO casar com navegadores in-app (Instagram/Facebook/WhatsApp), que reportam
 * `browser` — assim leads que abrem a Landing Page por esses apps NUNCA são
 * bloqueados.
 */
export function isInstalledPwa(): boolean {
  if (typeof window === "undefined") return false

  const displayStandalone =
    typeof window.matchMedia === "function" &&
    window.matchMedia("(display-mode: standalone)").matches

  // iOS Safari: app adicionado à tela inicial expõe navigator.standalone.
  const iosStandalone =
    (window.navigator as Navigator & { standalone?: boolean }).standalone === true

  return displayStandalone || iosStandalone
}

/** Endereço de produção que o usuário deve abrir no navegador. */
export const CREDITOS_WEB_HOST = "creditos.invenia.com.br"
export const CREDITOS_WEB_URL = `https://${CREDITOS_WEB_HOST}`
